import { MapPin, Navigation, Apple } from "lucide-react";

export const RouteBlock = ({ route, mapsUrl, appleUrl }) => {
  if (!route || route.length < 2) return null;
  return (
    <div className="mt-2 rounded-xl border border-teal-200 bg-teal-50/60 p-3" data-testid="route-block">
      <p className="text-xs font-bold uppercase tracking-wider text-teal-700 flex items-center gap-1.5">
        <Navigation className="w-3.5 h-3.5" /> Your food crawl · {route.length} stops
      </p>
      <ol className="mt-2 space-y-1">
        {route.map((t, i) => (
          <li key={t.id} className="flex items-center gap-2 text-sm">
            <span className="w-5 h-5 rounded-full bg-[#0FB5A6] text-white text-[11px] font-bold flex items-center justify-center shrink-0">{i + 1}</span>
            <a href={`/truck/${t.id}`} className="font-semibold text-slate-700 hover:text-[#0FB5A6]">{t.name}</a>
            {t.cuisine && <span className="text-slate-400 text-xs">· {t.cuisine}</span>}
          </li>
        ))}
      </ol>
      <div className="mt-3 flex flex-wrap gap-2">
        {mapsUrl && (
          <a href={mapsUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#0FB5A6] hover:bg-[#0E9E92] text-white text-xs font-bold transition-colors" data-testid="route-maps-link">
            <MapPin className="w-3.5 h-3.5" /> Google Maps
          </a>
        )}
        {appleUrl && (
          <a href={appleUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-slate-900 hover:bg-slate-800 text-white text-xs font-bold transition-colors" data-testid="route-apple-link">
            <Apple className="w-3.5 h-3.5" /> Apple Maps
          </a>
        )}
      </div>
    </div>
  );
};
